import { gql } from "@apollo/client";
import { AccountFragment } from "fragments/account";
import { KeyFragment } from "fragments/key";

// The signed-in account's own keys, at /key.
//
// Not to be confused with queries/organization-key, which reaches the same rows
// the long way round — down the domain tree, for an administrator looking at
// somebody else's organization. This one addresses the viewer's own, and is the
// same document bucketws and datum-repoflow send.
//
// The fragment is fragments/key, shared with both of those.

export const get = gql`
  query AccountKeyGet($keyId: String!) {
    viewer {
      id
      account {
        ...AccountFragment
        keys {
          id
          get(keyId: $keyId) {
            ...KeyFragment
          }
        }
      }
    }
  }
  ${AccountFragment}
  ${KeyFragment}
`;

export const list = gql`
  query AccountKeyList($input: ListInput) {
    viewer {
      id
      account {
        id
        keys {
          id
          list(input: $input) {
            id
            last
            items {
              ...KeyFragment
            }
          }
        }
      }
    }
  }
  ${KeyFragment}
`;




export const create = gql`
  mutation AccountKeyNew($input: KeyInputCreate!) {
    viewer {
      account {
        keys {
          create(input: $input) {
            keySecret
            ...KeyFragment
          }
        }
      }
    }
  }
  ${KeyFragment}
`;




export const remove = gql`
  mutation AccountKeyRemove($keyId: String!) {
    viewer {
      account {
        keys {
          get(keyId: $keyId) {
            remove
          }
        }
      }
    }
  }

`;




// `key/queries` is the id KeyQueries resolves to, and the organization section's
// ids are `${domain}/${orgId}/key/queries` — so this substring would match those
// too. That is correct rather than sloppy: both views read the same rows, and a
// key created here must not leave a stale listing behind in either.
export const update = ({ keyId }) => (cache) => {

  Object.keys(cache.data.data).forEach((key) => {
    if (key.includes(`key/queries`)) {
      cache.data.delete(key);
    }
  });
};
